var _style, _rect, _rect2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagPortugal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 45",
    style: {
      enableBackground: "new 0 0 70 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0-portugal{fill:#FF2424;}\r\n\t.st1-portugal{fill:#218421;}\r\n\t.st2-portugal{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFF00;}\r\n\t.st3-portugal{fill:#FFFFFF;}\r\n\t.st4-portugal{fill:#FF0000;}\r\n\t.st5-portugal{fill:#FFFF00;}\r\n\t.st6-portugal{fill:#003399;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_395",
    y: 0,
    className: "st0-portugal",
    width: 70,
    height: 45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_396",
    y: 0,
    className: "st1-portugal",
    width: 26.2,
    height: 45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    transform: "translate(17.286 11.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_502",
    className: "st2-portugal",
    d: "M17.6,17.7C14.3,17.6-1,8-1.1,6.5l0.8-1.4c1.5,2.2,17.2,11.5,18.7,11.2L17.6,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_503",
    className: "st2-portugal",
    d: "M-0.5,4.9c-0.3,0.8,4,3.5,9.2,6.6s9.6,5.1,10,4.8c0.1-0.1,0.1-0.2,0.1-0.3 c-0.1,0.1-0.2,0.1-0.4,0.1c-3.3-1.3-6.5-2.9-9.5-4.8C4.3,8.5,0.4,6-0.2,4.9c0-0.1-0.1-0.2-0.1-0.3h0L-0.5,4.9L-0.5,4.9L-0.5,4.9 L-0.5,4.9z M17.7,17.7c-0.1,0.1-0.2,0.1-0.4,0.1c-1.2-0.1-5-2-9.5-4.7c-5.2-3.1-9.5-6-9.1-6.7l0.1-0.2l0,0c-0.4,1.3,8.5,6.4,9,6.7 c5.2,3.2,9.5,5.1,9.9,4.6L17.7,17.7L17.7,17.7L17.7,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_504",
    className: "st2-portugal",
    d: "M9,7.4c3.3,0,7.5-0.5,9.8-1.4l-0.5-0.8C16.9,5.9,12.8,6.4,9,6.5C4.5,6.5,1.3,6.1-0.3,5 l-0.5,0.9C2.1,7.1,5.1,7.4,9,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_505",
    className: "st2-portugal",
    d: "M19,6c-1.2,0.5-2.6,0.9-3.9,1.1c-2,0.3-4,0.4-6.1,0.4C7,7.5,5.1,7.4,3.2,7.1 C1.8,6.9,0.4,6.6-0.9,6.1c0-0.1,0.1-0.1,0.1-0.2c1.3,0.5,2.6,0.9,4,1.1C5.1,7.1,7,7.3,9,7.3c2,0,4-0.1,6-0.4 c2.3-0.4,3.6-0.9,3.8-1.1L19,6L19,6z M18.5,5.2c-1.2,0.5-2.4,0.9-3.7,1C12.9,6.4,10.9,6.6,9,6.6c-1.9,0-3.7-0.1-5.6-0.4 c-1.3-0.2-2.6-0.5-3.9-1c0-0.1,0.1-0.1,0.1-0.2c1.2,0.5,2.5,0.8,3.8,1C7.2,6.5,11,6.4,14.7,5.9c1.3-0.1,2.5-0.5,3.6-1L18.5,5.2 L18.5,5.2L18.5,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_506",
    className: "st2-portugal",
    d: "M-2,11.4c2.1,1.1,6.6,1.7,10.9,1.7c3.9,0,9.1-0.6,11-1.6l-0.1-1.1c-0.6,0.9-6.1,1.8-11,1.8 S-0.5,11.4-2,10.4L-2,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_507",
    className: "st2-portugal",
    d: "M20,11.3v0.3c-0.3,0.3-2.1,0.9-4.4,1.2c-2.2,0.3-4.5,0.5-6.8,0.5c-2.2,0-4.3-0.1-6.4-0.4 c-1.6-0.2-3.1-0.6-4.6-1.2v-0.3c1.5,0.7,3,1.1,4.6,1.3C4.6,12.8,6.8,13,8.9,13c2.3,0,4.5-0.1,6.7-0.5C17.2,12.3,18.7,11.9,20,11.3 L20,11.3L20,11.3z M20,10.3v0.3c-0.3,0.3-2.1,0.9-4.4,1.2c-2.2,0.3-4.5,0.5-6.8,0.5c-2.2,0-4.3-0.1-6.4-0.4 c-1.6-0.2-3.1-0.6-4.6-1.2v-0.3c1.5,0.7,3,1.1,4.6,1.3C4.6,11.9,6.8,12,8.9,12c2.3,0,4.5-0.1,6.7-0.5C17.2,11.4,18.7,11,20,10.3 L20,10.3L20,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_508",
    className: "st2-portugal",
    d: "M9,17.5c-3.3-0.1-6.5-0.6-9.6-1.5l0.6,1c2.9,1,6,1.5,9.1,1.5c3.6-0.1,6.7-0.4,8.9-1.5l0.6-1 C17.1,16.7,11.9,17.5,9,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_509",
    className: "st2-portugal",
    d: "M18.2,16.7c-0.1,0.1-0.2,0.3-0.3,0.4c-1.1,0.4-2.2,0.7-3.4,0.9c-1.8,0.3-3.7,0.5-5.6,0.5 c-3.1,0-6.3-0.5-9.2-1.6l-0.1-0.2l0,0l0.2,0.1c2.9,1,6,1.5,9.1,1.5c1.8,0,3.6-0.2,5.4-0.5C15.7,17.6,16.9,17.3,18.2,16.7L18.2,16.7 L18.2,16.7L18.2,16.7z M18.7,15.8L18.7,15.8c-0.1,0.1-0.1,0.2-0.2,0.4c-1.4,0.4-2.8,0.8-4.3,0.9c-1.7,0.3-3.5,0.4-5.2,0.4 c-3.3,0-6.6-0.5-9.8-1.5l-0.1-0.2c3.2,0.9,6.5,1.4,9.9,1.5c1.7,0,3.5-0.2,5.2-0.4c1.4-0.2,2.9-0.5,4.3-0.9l0,0L18.7,15.8L18.7,15.8 L18.7,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_510",
    className: "st2-portugal",
    d: "M18.8,10.5c0,2.7-1,5.2-2.9,7.1c-1.9,1.8-4.4,2.9-7,2.9c-5.4,0-9.8-4.4-9.7-9.9c0,0,0,0,0,0 c0-2.8,1.3-5.5,3.5-7.4C4.5,1.8,6.8,1,9.3,1C14.5,1.2,18.6,5.3,18.8,10.5L18.8,10.5z M8.9-0.1c6,0,10.9,4.9,10.9,10.9 c0,6-4.9,10.9-10.9,10.9C2.9,21.7-2,16.8-2,10.8C-2,4.8,2.9-0.1,8.9-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_511",
    className: "st2-portugal",
    d: "M9-0.1c6,0,10.9,4.9,10.9,10.9c0,6-4.9,10.9-10.9,10.9C2.9,21.8-2,16.9-2,10.8c0,0,0,0,0,0 C-2,4.8,2.9-0.1,9-0.1z M-1.7,10.8c0,5.9,4.8,10.7,10.7,10.7c5.9,0,10.7-4.8,10.7-10.7C19.7,4.9,14.9,0.1,9,0.1 C3.1,0.1-1.7,4.9-1.7,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_512",
    className: "st2-portugal",
    d: "M9,0.8c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10c0,0,0,0,0,0 C-1,5.3,3.4,0.8,9,0.8z M-0.8,10.8c0,5.4,4.4,9.8,9.8,9.8c5.4,0,9.8-4.4,9.8-9.8C18.8,5.4,14.4,1,9,1C3.6,1-0.8,5.4-0.8,10.8 L-0.8,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_513",
    className: "st2-portugal",
    d: "M9.4-0.2H8.5v22h0.9L9.4-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_514",
    className: "st2-portugal",
    d: "M9.3-0.3h0.2v22.2H9.3C9.3,21.9,9.3-0.3,9.3-0.3z M8.4-0.3h0.2v22.2H8.4L8.4-0.3L8.4-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_515",
    className: "st2-portugal",
    d: "M19.9,11.2v-0.8l-0.7-0.6l-3.8-1l-5.4-0.6L3.6,8.6l-4.6,1.1L-2,10.4v0.8l2.4-1.1L6,9.2h5.4 l4,0.4l2.8,0.7L19.9,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_516",
    className: "st2-portugal",
    d: "M9,9.1c2.4,0,4.7,0.2,7.1,0.6c2.1,0.4,3.5,0.9,4,1.5v0.3c-0.6-0.7-2.5-1.2-4-1.5 c-2.3-0.4-4.7-0.6-7-0.6c-2.4,0-4.8,0.2-7.2,0.6c-1.6,0.3-3.6,0.9-3.9,1.5v-0.3c0.1-0.4,1.7-1,3.9-1.5C4.1,9.3,6.5,9.1,9,9.1z  M9,8.2c2.4,0,4.7,0.2,7.1,0.6c2.1,0.4,3.5,0.9,4,1.5v0.3c-0.6-0.7-2.5-1.2-4-1.5c-2.3-0.4-4.7-0.6-7-0.6c-2.4,0-4.8,0.2-7.2,0.6 C0.3,9.3-1.9,10-2.1,10.6v-0.3C-2,9.9-0.4,9.2,1.8,8.8C4.1,8.4,6.5,8.2,9,8.2L9,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_517",
    className: "st2-portugal",
    d: "M8.9,3.4c4.1,0,7.6,0.6,9.3,1.4l0.6,1C17.4,5,13.5,4.3,8.9,4.4c-3.7,0-7.7,0.4-9.7,1.5 l0.7-1.2C1.5,3.8,5.4,3.4,8.9,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_518",
    className: "st2-portugal",
    d: "M9,4.2c2.1,0,4.3,0.1,6.4,0.4c1.2,0.2,2.4,0.5,3.5,1L19,6c-1.2-0.5-2.4-0.9-3.7-1.1 C13.2,4.6,11.1,4.4,9,4.5c-2.1,0-4.3,0.1-6.4,0.4C1.4,5.1,0.2,5.5-0.9,6l0.2-0.3c1-0.5,2.1-0.8,3.2-1C4.7,4.3,6.8,4.2,9,4.2L9,4.2 L9,4.2z M9,3.3c2.1,0,4.1,0.1,6.1,0.4c1.1,0.2,2.2,0.5,3.2,1l0.3,0.4C18.1,4.7,16.4,4.2,15,4c-2-0.3-4-0.4-6-0.4 C6.9,3.5,4.8,3.7,2.8,4C1.7,4.1,0.7,4.5-0.3,4.9L0,4.6c0.9-0.4,1.8-0.7,2.8-0.8C4.8,3.4,6.9,3.3,9,3.3L9,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_519",
    className: "st2-portugal",
    d: "M14.4,15.4c-1.8-0.3-3.6-0.5-5.4-0.4c-6.8,0.1-9,1.4-9.2,1.8l-0.5-0.8c1.7-1.3,5.4-2,9.8-1.9 c2,0,3.9,0.2,5.9,0.5L14.4,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_520",
    className: "st2-portugal",
    d: "M8.9,14.8c1.9,0,3.7,0.1,5.5,0.4l-0.1,0.2c-1.8-0.3-3.6-0.4-5.4-0.4 c-2.4-0.1-4.9,0.2-7.2,0.8c-0.7,0.2-1.8,0.6-2,1l-0.1-0.2c0-0.2,0.7-0.7,2-1C4,15.1,6.5,14.8,8.9,14.8L8.9,14.8L8.9,14.8z M9,13.9 c2,0,4,0.2,5.9,0.5l-0.1,0.2c-1.9-0.3-3.9-0.5-5.8-0.5c-2.6-0.1-5.1,0.2-7.6,0.9c-0.8,0.2-2.1,0.7-2.2,1.1l-0.1-0.2 c0-0.4,1.2-0.8,2.3-1.1C3.9,14.1,6.4,13.8,9,13.9L9,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_521",
    className: "st2-portugal",
    d: "M18.7,16l-0.8,1.3l-2.3-2.1l-6.1-4.1L2.6,7.4L-1,6.1l0.8-1.4L0,4.6l2.2,0.6l7.3,3.8l4.2,2.7 l3.5,2.5l1.4,1.7L18.7,16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_522",
    className: "st2-portugal",
    d: "M-1.1,6.2c0.6-0.4,5.2,1.6,10,4.5s9.4,6.2,8.9,6.8l-0.1,0.2l-0.1,0c0,0,0.1-0.1,0-0.3 c-0.2-0.7-3.4-3.3-8.8-6.5c-5.2-3.1-9.6-5-10.1-4.5L-1.1,6.2L-1.1,6.2L-1.1,6.2z M18.8,16c0.4-0.8-3.9-4-9.1-7.1 C4.3,5.9,0.4,4-0.3,4.6l-0.2,0.3c0,0,0,0,0,0C-0.3,4.8-0.1,4.7,0,4.7c1.2,0,4.7,1.6,9.6,4.4c2.1,1.3,9.1,5.7,9,6.9 c0,0.1,0,0.1,0,0.2L18.8,16L18.8,16L18.8,16z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_398",
    transform: "translate(22.041 14.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_523",
    className: "st3-portugal",
    d: "M-2.2,8.4c0,3.6,2.9,6.5,6.6,6.6c3.6,0,6.6-2.9,6.6-6.6l0,0v-8.7l-13.1,0V8.4L-2.2,8.4 L-2.2,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_524",
    className: "st4-portugal",
    d: "M-2,8.4L-2,8.4c0,1.7,0.7,3.3,1.9,4.4c2.5,2.5,6.4,2.5,8.9,0c0,0,0,0,0,0 c1.2-1.2,1.8-2.8,1.8-4.4l0,0v-8.5H-2L-2,8.4 M8.1,2.4v5.4v0.6l0,0c0,0.2,0,0.3,0,0.5C7.9,9.7,7.6,10.5,7,11 c-0.7,0.7-1.7,1.1-2.7,1.1c-2.1,0-3.7-1.7-3.7-3.8v-6L8.1,2.4L8.1,2.4L8.1,2.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "castle3",
    transform: "translate(0.525 0.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_525",
    className: "st5-portugal",
    d: "M-1.7,1.6c0-0.3,0.2-0.6,0.5-0.8C-1,1-0.8,1.3-0.8,1.6L-1.7,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_526",
    className: "st5-portugal",
    d: "M-2.1,0.9l-0.1,0.7h0.5c0-0.3,0.2-0.6,0.5-0.7C-1,1-0.8,1.3-0.8,1.6h0.5l-0.1-0.7L-2.1,0.9 L-2.1,0.9L-2.1,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_527",
    className: "st5-portugal",
    d: "M-2.2,1.6h1.9c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.9C-2.2,1.7-2.3,1.7-2.2,1.6 C-2.3,1.6-2.2,1.6-2.2,1.6L-2.2,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_528",
    className: "st5-portugal",
    d: "M-1.5,1.6c0-0.2,0.1-0.4,0.3-0.5C-1.1,1.2-1,1.4-1,1.6H-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_529",
    className: "st5-portugal",
    d: "M-2.2,0.6h1.8c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.8C-2.2,0.7-2.2,0.7-2.2,0.6 C-2.2,0.6-2.2,0.6-2.2,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_530",
    className: "st5-portugal",
    d: "M-2.1,0.7h1.7c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.7C-2.2,0.9-2.2,0.9-2.1,0.7 C-2.2,0.8-2.1,0.8-2.1,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_531",
    className: "st5-portugal",
    d: "M-1.6-0.4h0.1v0.1h0.1v-0.1h0.1v0.1h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-1.6-0.4L-1.6-0.4L-1.6-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_532",
    className: "st5-portugal",
    d: "M-1-0.1l0,0.7h-0.5l0-0.7H-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1",
    className: "st5-portugal",
    d: "M-1.6,0.2l0,0.4h-0.5l0-0.4H-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_533",
    className: "st5-portugal",
    d: "M-0.5,0.2l0,0.4h-0.5l0-0.4H-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2",
    className: "st5-portugal",
    d: "M-2.1-0.1H-2V0h0.1v-0.1h0.1V0h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-2.1-0.1L-2.1-0.1L-2.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_534",
    className: "st5-portugal",
    d: "M-1-0.1h0.1V0h0.1v-0.1h0.1V0h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-1-0.1L-1-0.1L-1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_535",
    d: "M-1.3,0.1C-1.3,0.1-1.3,0.1-1.3,0.1C-1.2,0.1-1.2,0.1-1.3,0.1l0.1,0.2h-0.1V0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3",
    d: "M-1.9,0.3C-1.9,0.3-1.9,0.3-1.9,0.3C-1.8,0.3-1.8,0.3-1.9,0.3C-1.8,0.3-1.8,0.3-1.9,0.3l0.1,0.1h-0.1V0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_536",
    d: "M-0.7,0.3C-0.7,0.3-0.7,0.3-0.7,0.3C-0.6,0.3-0.6,0.3-0.7,0.3C-0.6,0.3-0.6,0.3-0.7,0.3l0.1,0.1h-0.1 V0.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    transform: "translate(0 5.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_537",
    className: "st5-portugal",
    d: "M-1.7,1.5c0-0.3,0.2-0.6,0.5-0.8C-1,0.8-0.8,1.2-0.8,1.5L-1.7,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_538",
    className: "st5-portugal",
    d: "M-2.1,0.7l-0.1,0.7h0.5c0-0.3,0.2-0.6,0.5-0.7C-1,0.9-0.8,1.1-0.8,1.4h0.5l-0.1-0.7 L-2.1,0.7L-2.1,0.7L-2.1,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_539",
    className: "st5-portugal",
    d: "M-2.2,1.4h1.9c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.9C-2.2,1.6-2.3,1.6-2.2,1.4 C-2.3,1.5-2.2,1.4-2.2,1.4L-2.2,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_540",
    className: "st5-portugal",
    d: "M-1.5,1.4c0-0.2,0.1-0.4,0.3-0.5C-1.1,1.1-1,1.2-1,1.4H-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_541",
    className: "st5-portugal",
    d: "M-2.2,0.4h1.8c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.8C-2.2,0.6-2.2,0.6-2.2,0.4 C-2.2,0.5-2.2,0.4-2.2,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_542",
    className: "st5-portugal",
    d: "M-2.1,0.6h1.7c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.7C-2.2,0.7-2.2,0.7-2.1,0.6 C-2.2,0.6-2.1,0.6-2.1,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    className: "st5-portugal",
    d: "M-1.6-0.6h0.1v0.1h0.1v-0.1h0.1v0.1h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-1.6-0.6L-1.6-0.6L-1.6-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    className: "st5-portugal",
    d: "M-1-0.3l0,0.7h-0.5l0-0.7H-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-2",
    className: "st5-portugal",
    d: "M-1.6,0.1l0,0.4h-0.5l0-0.4H-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_545",
    className: "st5-portugal",
    d: "M-0.5,0.1l0,0.4h-0.5l0-0.4H-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-2",
    className: "st5-portugal",
    d: "M-2.1-0.2H-2v0.1h0.1v-0.1h0.1v0.1h0.1v-0.1h0.1V0c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-2.1-0.2L-2.1-0.2L-2.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_546",
    className: "st5-portugal",
    d: "M-1-0.2h0.1v0.1h0.1v-0.1h0.1v0.1h0.1v-0.1h0.1V0c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 C-0.9,0.1-1,0-1,0L-1-0.2L-1-0.2L-1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    d: "M-1.3,0C-1.3-0.1-1.3-0.1-1.3,0C-1.2-0.1-1.2-0.1-1.3,0l0.1,0.2h-0.1V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-2",
    d: "M-1.9,0.2C-1.9,0.2-1.9,0.2-1.9,0.2C-1.8,0.2-1.8,0.2-1.9,0.2C-1.8,0.2-1.8,0.2-1.9,0.2l0.1,0.1h-0.1V0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    d: "M-0.7,0.2C-0.7,0.2-0.7,0.2-0.7,0.2C-0.6,0.2-0.6,0.2-0.7,0.2C-0.6,0.2-0.6,0.2-0.7,0.2l0.1,0.1h-0.1 V0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    transform: "translate(0.723 11.775) rotate(-45.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_549",
    className: "st5-portugal",
    d: "M-0.5-0.1c0-0.3,0.2-0.6,0.5-0.8c0.3,0.1,0.5,0.4,0.5,0.8L-0.5-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_550",
    className: "st5-portugal",
    d: "M-0.9-0.8L-1-0.1l0.5,0c0-0.3,0.2-0.6,0.4-0.7c0.3,0.1,0.5,0.4,0.5,0.7l0.5,0L0.8-0.8 L-0.9-0.8L-0.9-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_551",
    className: "st5-portugal",
    d: "M-1-0.1l1.9,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1L-1,0C-1,0-1.1,0-1-0.1 C-1.1-0.1-1-0.1-1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_552",
    className: "st5-portugal",
    d: "M-0.3-0.1c0-0.2,0.1-0.4,0.3-0.5c0.2,0.1,0.3,0.3,0.3,0.5L-0.3-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_553",
    className: "st5-portugal",
    d: "M-1-1.1l1.8,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1L-1-1C-1-1-1-1-1-1.1 C-1-1.1-1-1.1-1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    className: "st5-portugal",
    d: "M-0.9-1l1.7,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1l-1.7,0C-1-0.8-1-0.9-0.9-1 C-1-0.9-1-1-0.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    className: "st5-portugal",
    d: "M-0.4-2.1h0.1l0,0.1h0.1l0-0.1H0l0,0.1h0.1l0-0.1h0.1l0,0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0 h-0.5c0,0-0.1,0-0.1-0.1L-0.4-2.1L-0.4-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    className: "st5-portugal",
    d: "M0.1-1.9l0,0.7l-0.5,0l0-0.7L0.1-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-3",
    className: "st5-portugal",
    d: "M-0.4-1.5l0,0.4h-0.5l0-0.4H-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    className: "st5-portugal",
    d: "M0.7-1.5l0,0.4H0.3l0-0.4H0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-3",
    className: "st5-portugal",
    d: "M-1-1.8h0.1v0.1h0.1v-0.1h0.1v0.1h0.1l0-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0l-0.5,0 c0,0-0.1,0-0.1-0.1V-1.8L-1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    className: "st5-portugal",
    d: "M0.2-1.8h0.1v0.1h0.1v-0.1l0.1,0v0.1h0.1v-0.1h0.1l0,0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0 l-0.5,0c0,0-0.1,0-0.1-0.1L0.2-1.8L0.2-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    d: "M-0.1-1.6C-0.1-1.7-0.1-1.7-0.1-1.6C0-1.7,0-1.7-0.1-1.6L0-1.5h-0.1L-0.1-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-3",
    d: "M-0.7-1.4C-0.7-1.4-0.7-1.4-0.7-1.4C-0.6-1.4-0.6-1.4-0.7-1.4l0.1,0.1h-0.1V-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    d: "M0.5-1.4C0.5-1.4,0.5-1.4,0.5-1.4C0.5-1.4,0.6-1.4,0.5-1.4l0.1,0.1H0.5V-1.4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_390",
    transform: "translate(5.723 0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    className: "st5-portugal",
    d: "M-1.9,1.6c0-0.3,0.2-0.6,0.5-0.8C-1.1,1-0.9,1.3-0.9,1.6L-1.9,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    className: "st5-portugal",
    d: "M-2.2,0.9l-0.1,0.7h0.5c0-0.3,0.2-0.6,0.5-0.7C-1.1,1-0.9,1.3-0.9,1.6h0.5l-0.1-0.7 L-2.2,0.9L-2.2,0.9L-2.2,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    className: "st5-portugal",
    d: "M-2.3,1.6h1.9c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.9C-2.4,1.7-2.4,1.7-2.3,1.6 C-2.4,1.6-2.4,1.6-2.3,1.6L-2.3,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_564",
    className: "st5-portugal",
    d: "M-1.7,1.6c0-0.2,0.1-0.4,0.3-0.5c0.2,0.1,0.3,0.3,0.3,0.5H-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_565",
    className: "st5-portugal",
    d: "M-2.3,0.6h1.8c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.8C-2.3,0.7-2.4,0.7-2.3,0.6 C-2.4,0.6-2.3,0.6-2.3,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_566",
    className: "st5-portugal",
    d: "M-2.3,0.7h1.7c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1h-1.7C-2.3,0.9-2.3,0.9-2.3,0.7 C-2.3,0.8-2.3,0.8-2.3,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_567",
    className: "st5-portugal",
    d: "M-1.7-0.4h0.1v0.1h0.1v-0.1h0.1v0.1h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-1.7-0.4L-1.7-0.4L-1.7-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_568",
    className: "st5-portugal",
    d: "M-1.2-0.1l0,0.7h-0.5l0-0.7H-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-4",
    className: "st5-portugal",
    d: "M-1.8,0.2l0,0.4h-0.5l0-0.4H-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_569",
    className: "st5-portugal",
    d: "M-0.6,0.2l0,0.4H-1l0-0.4H-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-4",
    className: "st5-portugal",
    d: "M-2.3-0.1h0.1V0h0.1v-0.1h0.1V0h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0h-0.5 c0,0-0.1,0-0.1-0.1L-2.3-0.1L-2.3-0.1L-2.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_570",
    className: "st5-portugal",
    d: "M-1.1-0.1H-1V0h0.1v-0.1h0.1V0h0.1v-0.1h0.1v0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0H-1 c0,0-0.1,0-0.1-0.1L-1.1-0.1L-1.1-0.1L-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_571",
    d: "M-1.4,0.1C-1.4,0.1-1.4,0.1-1.4,0.1C-1.4,0.1-1.3,0.1-1.4,0.1l0.1,0.2h-0.1V0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-4",
    d: "M-2,0.3C-2,0.3-2,0.3-2,0.3C-2,0.3-1.9,0.3-2,0.3C-1.9,0.3-1.9,0.3-2,0.3l0.1,0.1H-2V0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_572",
    d: "M-0.9,0.3C-0.9,0.3-0.8,0.3-0.9,0.3C-0.8,0.3-0.8,0.3-0.9,0.3C-0.8,0.3-0.8,0.3-0.9,0.3l0.1,0.1h-0.1 V0.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_393",
    transform: "translate(12.963 13.828) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle-2",
    transform: "translate(0 11.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_573",
    className: "st5-portugal",
    d: "M3.2,0.6c0,0.3,0.2,0.6,0.5,0.8c0.3-0.1,0.5-0.4,0.5-0.8L3.2,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    className: "st5-portugal",
    d: "M2.8,1.4L2.7,0.7h0.5c0,0.3,0.2,0.6,0.4,0.7C3.9,1.2,4.1,1,4.1,0.7h0.5L4.4,1.4L2.8,1.4 L2.8,1.4L2.8,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    className: "st5-portugal",
    d: "M2.7,0.7h1.9c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H2.7C2.6,0.5,2.6,0.5,2.7,0.7 C2.6,0.6,2.6,0.7,2.7,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    className: "st5-portugal",
    d: "M3.4,0.7c0,0.2,0.1,0.4,0.3,0.5C3.8,1,3.9,0.9,3.9,0.7H3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_577",
    className: "st5-portugal",
    d: "M2.7,1.7h1.8c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H2.7C2.7,1.5,2.6,1.5,2.7,1.7 C2.6,1.6,2.7,1.7,2.7,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_578",
    className: "st5-portugal",
    d: "M2.8,1.5h1.7c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H2.8C2.7,1.3,2.7,1.4,2.8,1.5 C2.7,1.5,2.7,1.5,2.8,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_579",
    className: "st5-portugal",
    d: "M3.3,2.7h0.1V2.6h0.1v0.1h0.1V2.6h0.1v0.1h0.1V2.4c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0H3.4 c0,0-0.1,0-0.1,0.1V2.7L3.3,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_580",
    className: "st5-portugal",
    d: "M3.8,2.4l0-0.7H3.4l0,0.7L3.8,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-5",
    className: "st5-portugal",
    d: "M3.2,2l0-0.4H2.8l0,0.4H3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_581",
    className: "st5-portugal",
    d: "M4.4,2l0-0.4H4L4,2H4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-5",
    className: "st5-portugal",
    d: "M2.7,2.3h0.1V2.2H3v0.1h0.1V2.2h0.1v0.1h0.1V2.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0H2.8 c0,0-0.1,0-0.1,0.1V2.3L2.7,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    className: "st5-portugal",
    d: "M3.9,2.3H4V2.2h0.1v0.1h0.1V2.2h0.1v0.1h0.1V2.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0H4 c0,0-0.1,0-0.1,0.1V2.3L3.9,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    d: "M3.6,2.1C3.6,2.2,3.6,2.2,3.6,2.1C3.6,2.2,3.7,2.2,3.6,2.1L3.7,2H3.6V2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-5",
    d: "M3,1.9C3,1.9,3,1.9,3,1.9C3.1,1.9,3.1,1.9,3,1.9l0.1-0.1H3V1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_584",
    d: "M4.2,1.9C4.2,1.9,4.2,1.9,4.2,1.9C4.2,1.9,4.2,1.9,4.2,1.9l0.1-0.1H4.2V1.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    transform: "translate(0 5.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_585",
    className: "st5-portugal",
    d: "M3.2,0.8c0,0.3,0.2,0.6,0.5,0.8c0.3-0.1,0.5-0.4,0.5-0.8L3.2,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_586",
    className: "st5-portugal",
    d: "M2.8,1.5L2.7,0.8h0.5c0,0.3,0.2,0.6,0.4,0.7c0.3-0.1,0.5-0.4,0.5-0.7h0.5L4.4,1.5L2.8,1.5 L2.8,1.5L2.8,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_587",
    className: "st5-portugal",
    d: "M2.7,0.8h1.9c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H2.7C2.6,0.6,2.6,0.7,2.7,0.8 C2.6,0.8,2.6,0.8,2.7,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_588",
    className: "st5-portugal",
    d: "M3.4,0.8c0,0.2,0.1,0.4,0.3,0.5C3.8,1.2,3.9,1,3.9,0.8H3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_589",
    className: "st5-portugal",
    d: "M2.7,1.8h1.8c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H2.7C2.7,1.6,2.6,1.7,2.7,1.8 C2.6,1.8,2.7,1.8,2.7,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_590",
    className: "st5-portugal",
    d: "M2.8,1.6h1.7c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H2.8C2.7,1.5,2.7,1.5,2.8,1.6 C2.7,1.6,2.7,1.6,2.8,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_591",
    className: "st5-portugal",
    d: "M3.3,2.8h0.1V2.7h0.1v0.1h0.1V2.7h0.1v0.1h0.1V2.6c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0H3.4 c0,0-0.1,0-0.1,0.1V2.8L3.3,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_592",
    className: "st5-portugal",
    d: "M3.8,2.5l0-0.7H3.4l0,0.7L3.8,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-6",
    className: "st5-portugal",
    d: "M3.2,2.2l0-0.4H2.8l0,0.4H3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_593",
    className: "st5-portugal",
    d: "M4.4,2.2l0-0.4H4l0,0.4H4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-6",
    className: "st5-portugal",
    d: "M2.7,2.5h0.1V2.4H3v0.1h0.1V2.4h0.1v0.1h0.1V2.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0H2.8 c0,0-0.1,0-0.1,0.1V2.5L2.7,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_594",
    className: "st5-portugal",
    d: "M3.9,2.5H4V2.4h0.1v0.1h0.1V2.4h0.1v0.1h0.1V2.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0H4 c0,0-0.1,0-0.1,0.1V2.5L3.9,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_595",
    d: "M3.6,2.3C3.6,2.3,3.6,2.3,3.6,2.3C3.6,2.3,3.7,2.3,3.6,2.3l0.1-0.2H3.6V2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-6",
    d: "M3,2C3,2.1,3,2.1,3,2C3.1,2.1,3.1,2.1,3,2l0.1-0.1H3V2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_596",
    d: "M4.2,2C4.2,2.1,4.2,2.1,4.2,2C4.2,2.1,4.2,2.1,4.2,2l0.1-0.1H4.2V2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_392",
    transform: "translate(2.318 0) rotate(45.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_597",
    className: "st5-portugal",
    d: "M2.9-1.1c0,0.3,0.2,0.6,0.5,0.8c0.3-0.1,0.5-0.4,0.5-0.8L2.9-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_598",
    className: "st5-portugal",
    d: "M2.5-0.4L2.5-1.1h0.5c0,0.3,0.2,0.6,0.4,0.7c0.3-0.1,0.5-0.4,0.5-0.7h0.5L4.2-0.4L2.5-0.4 L2.5-0.4L2.5-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_599",
    className: "st5-portugal",
    d: "M2.4-1.1l1.9,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1l-1.9,0C2.4-1.2,2.4-1.2,2.4-1.1 C2.4-1.1,2.4-1.1,2.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_600",
    className: "st5-portugal",
    d: "M3.1-1.1c0,0.2,0.1,0.4,0.3,0.5c0.2-0.1,0.3-0.3,0.3-0.5H3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_601",
    className: "st5-portugal",
    d: "M2.5-0.1l1.8,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1l-1.8,0C2.4-0.2,2.4-0.2,2.5-0.1 C2.4-0.1,2.4-0.1,2.5-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_602",
    className: "st5-portugal",
    d: "M2.5-0.2l1.7,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1l-1.7,0C2.5-0.4,2.4-0.3,2.5-0.2 C2.4-0.3,2.5-0.2,2.5-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_603",
    className: "st5-portugal",
    d: "M3.1,0.9h0.1V0.8h0.1v0.1l0.1,0V0.8h0.1v0.1h0.1V0.7c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0l-0.5,0 c0,0-0.1,0-0.1,0.1V0.9L3.1,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_604",
    className: "st5-portugal",
    d: "M3.6,0.6l0-0.7l-0.5,0l0,0.7L3.6,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-7",
    className: "st5-portugal",
    d: "M3,0.3l0-0.4l-0.5,0l0,0.4L3,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_605",
    className: "st5-portugal",
    d: "M4.2,0.3l0-0.4l-0.5,0l0,0.4L4.2,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-7",
    className: "st5-portugal",
    d: "M2.5,0.6h0.1V0.5h0.1v0.1h0.1V0.5h0.1v0.1l0.1,0V0.4c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0l-0.5,0 c0,0-0.1,0-0.1,0.1V0.6L2.5,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_606",
    className: "st5-portugal",
    d: "M3.7,0.6h0.1V0.5h0.1v0.1H4V0.5l0.1,0v0.1l0.1,0V0.4c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0l-0.5,0 c0,0-0.1,0-0.1,0.1V0.6L3.7,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_607",
    d: "M3.3,0.4C3.3,0.4,3.3,0.5,3.3,0.4C3.4,0.5,3.4,0.4,3.3,0.4l0.1-0.2l-0.1,0V0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-7",
    d: "M2.7,0.2C2.7,0.2,2.8,0.2,2.7,0.2C2.8,0.2,2.8,0.2,2.7,0.2L2.8,0L2.7,0V0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_608",
    d: "M3.9,0.2C3.9,0.2,3.9,0.2,3.9,0.2C4,0.2,4,0.2,3.9,0.2L4,0L3.9,0V0.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "quina",
    transform: "translate(5.918 6.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_609",
    className: "st6-portugal",
    d: "M-2.4,0.6L-2.4,0.6c0,0.2,0.1,0.5,0.2,0.6c0.3,0.3,0.8,0.4,1.1,0.1c0,0,0,0,0.1-0.1 C-0.8,1-0.8,0.8-0.8,0.6v-1.2h-1.7L-2.4,0.6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_156",
    className: "st3-portugal",
    cx: -2,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_157",
    className: "st3-portugal",
    cx: -1.1,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_158",
    className: "st3-portugal",
    cx: -1.6,
    cy: 0.3,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_159",
    className: "st3-portugal",
    cx: -2,
    cy: 0.8,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_160",
    className: "st3-portugal",
    cx: -1.1,
    cy: 0.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_394",
    transform: "translate(5.918 3.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_610",
    className: "st6-portugal",
    d: "M-2.4,0.7L-2.4,0.7c0,0.2,0.1,0.5,0.2,0.6c0.3,0.3,0.8,0.4,1.1,0.1c0,0,0,0,0.1-0.1 c0.2-0.2,0.2-0.4,0.2-0.6v-1.2h-1.7L-2.4,0.7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_161",
    className: "st3-portugal",
    cx: -2,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_162",
    className: "st3-portugal",
    cx: -1.1,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_163",
    className: "st3-portugal",
    cx: -1.6,
    cy: 0.4,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_164",
    className: "st3-portugal",
    cx: -2,
    cy: 0.8,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_165",
    className: "st3-portugal",
    cx: -1.1,
    cy: 0.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_395",
    transform: "translate(3.553 6.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_611",
    className: "st6-portugal",
    d: "M-2.3,0.6L-2.3,0.6c0,0.2,0.1,0.5,0.2,0.6C-1.8,1.5-1.3,1.6-1,1.3c0,0,0,0,0.1-0.1 C-0.8,1-0.7,0.8-0.7,0.6v-1.2h-1.7L-2.3,0.6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_166",
    className: "st3-portugal",
    cx: -2,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_167",
    className: "st3-portugal",
    cx: -1,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_168",
    className: "st3-portugal",
    cx: -1.5,
    cy: 0.3,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_169",
    className: "st3-portugal",
    cx: -2,
    cy: 0.8,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_170",
    className: "st3-portugal",
    cx: -1,
    cy: 0.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_396",
    transform: "translate(8.277 6.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_612",
    className: "st6-portugal",
    d: "M-2.5,0.6L-2.5,0.6c0,0.2,0.1,0.5,0.2,0.6c0.3,0.3,0.8,0.4,1.1,0.1c0,0,0,0,0.1-0.1 C-0.9,1-0.8,0.8-0.8,0.6v-1.2h-1.7L-2.5,0.6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_171",
    className: "st3-portugal",
    cx: -2.1,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_172",
    className: "st3-portugal",
    cx: -1.2,
    cy: -0.1,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_173",
    className: "st3-portugal",
    cx: -1.6,
    cy: 0.3,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_174",
    className: "st3-portugal",
    cx: -2.1,
    cy: 0.8,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_175",
    className: "st3-portugal",
    cx: -1.2,
    cy: 0.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_397",
    transform: "translate(5.918 9.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_613",
    className: "st6-portugal",
    d: "M-2.4,0.5L-2.4,0.5c0,0.2,0.1,0.5,0.2,0.6c0.3,0.3,0.8,0.4,1.1,0.1c0,0,0,0,0.1-0.1 C-0.8,1-0.8,0.7-0.8,0.5v-1.2h-1.7L-2.4,0.5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_176",
    className: "st3-portugal",
    cx: -2,
    cy: -0.2,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_177",
    className: "st3-portugal",
    cx: -1.1,
    cy: -0.2,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_178",
    className: "st3-portugal",
    cx: -1.6,
    cy: 0.2,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_179",
    className: "st3-portugal",
    cx: -2,
    cy: 0.7,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_180",
    className: "st3-portugal",
    cx: -1.1,
    cy: 0.7,
    r: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPortugal);
export default __webpack_public_path__ + "static/media/FlagPortugal.f5f101b4f51deac0bfea206b9dd8d2ce.svg";
export { ForwardRef as ReactComponent };